import styles from './PlansScreen.module.css';

interface PlansScreenProps {
  readonly navigateBack?: () => void;
  readonly navigateToAccess?: () => void;
}

const plans = [
  {
    name: 'Professional',
    capacity: '1 titular + 1 dependiente',
    operations: 'Hasta 2 operativas',
    inventory: '25 propiedades activas',
    media: '16 fotos por propiedad',
  },
  {
    name: 'Executive',
    capacity: '1 titular + 3 dependientes',
    operations: 'Hasta 4 operativas',
    inventory: '75 propiedades activas',
    media: '16 fotos por propiedad',
  },
  {
    name: 'Signature',
    capacity: '1 titular + 9 dependientes',
    operations: 'Hasta 10 operativas',
    inventory: '150 propiedades activas',
    media: '16 fotos por propiedad',
  },
] as const;

function defaultBack(): void {
  if (window.history.length > 1) {
    window.history.back();
    return;
  }
  window.location.assign('/');
}

function defaultAccess(): void {
  window.location.assign('/');
}

export function PlansScreen({
  navigateBack = defaultBack,
  navigateToAccess = defaultAccess,
}: PlansScreenProps): React.JSX.Element {
  return (
    <main className={styles.shell}>
      <div className={styles.heroImage} aria-hidden="true" />
      <header className={styles.appBar}>
        <button type="button" className={styles.back} onClick={navigateBack}>
          ← <span>Volver</span>
        </button>
        <a className={styles.brand} href="/" aria-label="Alpha MLS">
          <strong>Alpha•MLS</strong>
          <span>GLOBAL</span>
        </a>
        <button type="button" className={styles.access} onClick={navigateToAccess}>
          Acceso
        </button>
      </header>

      <section className={styles.hero}>
        <p>MEMBRESÍAS PROFESIONALES</p>
        <h1>Elige la capacidad operativa de tu práctica inmobiliaria.</h1>
        <span>
          La beta conserva pagos externos. Los precios comerciales aún no
          están ratificados; aquí sólo se muestran capacidades ya definidas.
        </span>
      </section>

      <section className={styles.planGrid} aria-label="Planes Alpha MLS">
        {plans.map((plan) => (
          <article key={plan.name}>
            <div>
              <small>ALPHA•MLS</small>
              <h2>{plan.name}</h2>
            </div>
            <dl>
              <div>
                <dt>Equipo</dt>
                <dd>{plan.capacity}</dd>
              </div>
              <div>
                <dt>Capacidad</dt>
                <dd>{plan.operations}</dd>
              </div>
              <div>
                <dt>Inventario</dt>
                <dd>{plan.inventory}</dd>
              </div>
              <div>
                <dt>Media</dt>
                <dd>{plan.media}</dd>
              </div>
            </dl>
            <button type="button" onClick={navigateToAccess}>
              Solicitar acceso
            </button>
          </article>
        ))}
      </section>

      <section className={styles.note}>
        <strong>Customer y Owner</strong>
        <span>
          Estas relaciones no consumen una licencia comercial. El entitlement
          se aplica a la persona profesional activa.
        </span>
      </section>
    </main>
  );
}
